import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { TokenData } from "app/main/apps/shared/interfaces/token-data.interface";
import { UsuarioDTO } from "app/main/apps/shared/interfaces/usuario.interface";
import { config as CONFIG } from "app/app.config";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { DialogCambiarClaveComponent } from "../dialog-cambiar-clave/dialog-cambiar-clave.component";
import { DialogEditarPerfilComponent } from "../dialog-editar-perfil/dialog-editar-perfil.component";
import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { MaxSizeValidator } from "@angular-material-components/file-input";
import { FormBuilder, FormGroup } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "@auth0/auth0-angular";
@Component({
    selector: "app-ficha",
    templateUrl: "./ficha.component.html",
    styleUrls: ["./ficha.component.scss"],
})
export class FichaComponent implements OnInit {
    //formulario: FormGroup;
    @Input() perfilUsuario: UsuarioDTO;
    @Input() tokenData: TokenData;
    foto: string="";
    file: File = null;
    @ViewChild("foto", { static: false }) inputValue: ElementRef;
    config;
    constructor(private _dialogSrvc: DialogService,
                private _usuarioSrvc: UsuarioService,
                private _notificacionSrvc: NotificacionesService,
                private _auth: AuthService
                //private _sanitizer: DomSanitizer
                //private fb: FormBuilder
                ) {
        this.config = CONFIG;
    }

    ngOnInit(): void {

        this._auth.user$.subscribe(r=>{         
            this.foto=`${r.picture}`;
        })

       this._usuarioSrvc.fotoChanged$.subscribe(resp=>{
        let current = new Date();
           this.foto=`${this.foto}?${current.getTime().toString()}`
       })

    }

    //cambiarFoto(){
    //    document.querySelector("input").click();
    //}


    cambiarClave(){
        const dialogRef = this._dialogSrvc.abrirDialog(
                DialogCambiarClaveComponent,
                "clase-dialog",
                "700px",
                event
            );
    
            dialogRef.afterClosed().subscribe((perfil) => {
                if (perfil){
                    this._usuarioSrvc.saveClave(perfil.clave1).subscribe(resp=>{
                        this._notificacionSrvc.mostrarNotificacion("La clave ha cambiado con exito","success");
                    })
                }
            });
    }

    editarPerfil(){
        const dialogRef = this._dialogSrvc.abrirDialog(
                DialogEditarPerfilComponent,
                "clase-dialog",
                "700px",
                event
            );
    
            dialogRef.afterClosed().subscribe((perfil) => {
                if (perfil){
                    this._usuarioSrvc.saveCorreo(perfil.email).subscribe(resp=>{
                        this._notificacionSrvc.mostrarNotificacion("Correo cambiado con exito","success");
                        this.perfilUsuario.email=perfil.email;
                    })
                }
            });
    }

    getFile(event) {
        const file = event && event.item(0);
        this.file = file;
        this._usuarioSrvc.saveFoto(this.perfilUsuario.codigoFoto, file).subscribe(resp=>{
            this._usuarioSrvc.fotoChanged$.next(true);

            //console.log(resp);
            //this._usuarioSrvc.fetchFoto(this.perfilUsuario.codigoFoto).subscribe(resp=>{
            //    this._usuarioSrvc.fotoChanged$.next(true);

                //let objectURL = URL.createObjectURL(resp);
                //this._usuarioSrvc.fotoChanged$.next(this._sanitizer.bypassSecurityTrustResourceUrl(
                //    objectURL
                //));

            //})
        })


    }

}
